import { useMutation } from "@tanstack/react-query";

import type { MutationConfig } from "@/lib/react-query";
import { authApi } from "@/lib/api-client";
import { apiPaths } from "@/config/paths";
import { AxiosResponse } from "axios";

type ResetPasswordInput = {
  email: string;
  code: string;
  password: string;
};

type ResetPasswordResponse = {
  success: boolean;
  message?: string;
};

const resetPassword = ({ data }: { data: ResetPasswordInput }): Promise<AxiosResponse<ResetPasswordResponse>> => {
  return authApi.post<ResetPasswordInput, AxiosResponse<ResetPasswordResponse>>(
    apiPaths.auth.resetPasswordChange.getPath(),
    data
  );
};

type UseResetPasswordOptions = {
  mutationConfig?: MutationConfig<typeof resetPassword>;
};

export const useResetPassword = ({ mutationConfig }: UseResetPasswordOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, ...args) => {
      onSuccess?.(data, ...args);
    },
    ...restConfig,
    mutationFn: resetPassword,
  });
};
